// removed by extract-text-webpack-plugin
module.exports = {"container":"BiHon","separator":"_1st_W","item":"_2GYRv"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-dropdown.scss
// module id = 707
// module chunks = 3 4 5 6 7